<template>
<div class="cont">
  <!--标题-->
  <div class="detailsTitle">
    <h4>实时监控</h4>
  </div>
  <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="90px" size="mini">
        <div class=" inpBox">
      <el-form-item label="车队:" prop="fleetIds">
        <el-select v-model="searchFrom.fleetIds" placeholder="请选择">
          <el-option
            v-for="(item,index) in fleetOptions"
            :key="index"
            :label="item.fleetName"
            :value="item.fleet">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态:" prop="vehicleStatus">
        <el-select v-model="searchFrom.vehicleStatus" placeholder="请选择">
          <el-option
            v-for="(item,index) in statusOptions"
            :key="index"
            :label="item.showName"
            :value="item.itemNo">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
          <el-button type="primary" @click="searchClick" btnCode='001P005B001' v-if="btnFlg[0]">查询</el-button>
          <el-button type="primary" @click="chongZhiClick" btnCode='001P005B002' v-if="btnFlg[1]">重置</el-button>
        </el-form-item>
        </div>
      </el-form>
    </div>
  <div class="map" v-loading="loading">
    <div id="map"></div>
  </div>
</div>
</template>
<script>
import AMap from 'AMap'
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import {
  fleetList, // 车队列表
  getVehicleMonitor, // 实时监控
  getDictionaryList // 字典
} from '@/api/zhb-sgHarbour'
export default {
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ['001P005B001', '001P005B002' ],
      marker: null,
      loading: false,
      map: null,
      searchFrom: {
        fleetIds: '',
        vehicleStatus: ''
      },
      // 车队
      fleetOptions: [],
      statusOptions: [],
      dataList: [
        {
          vehicleStatus: '',
          vhcLat: '',
          vhcLon: ''
        }
      ],
      infoWindow: null,
      center: null,
      lngLat: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/sgWaybill/realTimeMonitor')
  },
  mounted () {
    // this.getVehicleMonitor()
    this.fleetOptionsInit()
    this.getDictionaryList() // 字典
    this.loading = true
    getVehicleMonitor({
      fleetIds: this.searchFrom.fleetIds,
      vehicleStatus: this.searchFrom.vehicleStatus
    }).then(res => {
      this.loading = false
      this.lngLat = res.multiCoordinate
      this.dataList = []
      //  console.log(this.lngLat)
      let list = []
      res.gps.forEach((im, ix) => {
        if (im.vehicleStatus == '1') {
          im.vehicleStatus = '待接单'
        } else if (im.vehicleStatus == '2') {
          im.vehicleStatus = '已接单'
        } else {
          im.vehicleStatus = '休息中'
        }
        let obj = {}
        obj.vhcLat = im.gps[1]
        obj.vhcLon = im.gps[0]
        obj.vehicleStatus = im.vehicleStatus
        obj.vehicleNo = im.vehicleNo
        obj.driverName = im.driverName
        obj.organizationName = im.organizationName
        list.push(obj)
      })
      this.dataList = list
      console.log(this.dataList, 'dataList')
      this.initMap()
      this.markerOption()
      this.weilan1()
    }).catch(err => {
      this.loading = false
      DonMessage.error(err.message)
    })
  },
  methods: {
    fleetOptionsInit () {
      fleetList().then(res => {
        this.fleetOptions = res
        this.fleetOptions.unshift({ 'fleet': '', 'fleetName': '全部' })
      })
    },
    // 字典
    getDictionaryList () {
      getDictionaryList({
        groupNo: 'vehicle_status'
      }).then(res => {
        this.statusOptions = res.vehicle_status
        this.statusOptions.unshift({ 'itemNo': '', 'showName': '全部' })
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    getVehicleMonitor () {
      getVehicleMonitor({
        fleetIds: this.searchFrom.fleetIds,
        vehicleStatus: this.searchFrom.vehicleStatus
      }).then(res => {
        this.lngLat = res.multiCoordinate
        this.dataList = []
        //  console.log(this.lngLat)
        let list = []
        res.gps.forEach((im, ix) => {
          if (im.vehicleStatus == '1') {
            im.vehicleStatus = '待接单'
          } else if (im.vehicleStatus == '2') {
            im.vehicleStatus = '已接单'
          } else {
            im.vehicleStatus = '休息中'
          }
          let obj = {}
          obj.vhcLat = im.gps[1]
          obj.vhcLon = im.gps[0]
          obj.vehicleStatus = im.vehicleStatus
          obj.vehicleNo = im.vehicleNo
          obj.driverName = im.driverName
          obj.organizationName = im.organizationName
          list.push(obj)
        })
        this.dataList = list
        console.log(this.dataList, 'dataList')
        this.initMap()
        this.markerOption()
        this.weilan1()
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    initMap () {
      let center = []
      // console.log(this.dataList[0].vhcLon,'vhcLon')
      // center.push(this.dataList[0].vhcLon, this.dataList[0].vhcLat)
      this.map = new AMap.Map('map', {
        center: [116.397428, 39.90923], // [纬度，经度]
        // center: center,
        resizeEnable: true,
        zoom: 12
      })
      this.map.setFitView()
    },
    markerOption () {
      if (this.marker) {
        this.map.clearMap()
      }
      let icon = null
      let marker
      console.log(this.dataList, 'vhcLat')
      this.dataList.forEach((item, index) => {
        if (item.vehicleStatus == '休息中') { // 空闲
          icon = new AMap.Icon({
            image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/zhbcps/Applets/kongxian.png', // 黑色
            size: new AMap.Size(25, 25), // 图标大小
            imageSize: new AMap.Size(25, 15)
          })
        } else if (item.vehicleStatus == '待接单') { // 待派车
          icon = new AMap.Icon({
            image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/zhbcps/Applets/daipaiche.png', // 蓝色
            size: new AMap.Size(25, 25), // 图标大小
            imageSize: new AMap.Size(25, 15)
          })
        } else { // 已接单
          icon = new AMap.Icon({
            image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/zhbcps/Applets/renwuzhong.png',
            size: new AMap.Size(25, 25), // 图标大小
            imageSize: new AMap.Size(25, 15)
          })
        }
        // if (item.vhcLat !== null && item.vhcLon !== null) {
        // 创建一个 Marker 实例：
        // console.log(item.vhcLon, item.vhcLat, '1111')
        marker = new AMap.Marker({
          position: new AMap.LngLat(item.vhcLon, item.vhcLat), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          icon: icon,
          title: item.vehicleStatus
        })

        // 将创建的点标记添加到已有的地图实例：
        // this.map.add(marker)
        // this.marker = new AMap.Marker({
        //   icon: new AMap.Icon({
        //     image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/zhbcps/Applets/kongxian.png',
        //     size: new AMap.Size(30, 30), // 图标大小
        //     imageSize: new AMap.Size(30, 20),
        //     position: [116.406315, 39.908775],
        //     offset: new AMap.Pixel(-10, -34)
        //   })
        // })
        // this.marker.setMap(this.map)
        // }
        marker.content = item.vehicleNo + '<br/>' + item.driverName + '<br/>' + item.vehicleStatus + '<br/>' + item.organizationName
        console.log(item, 'item')
        // marker.on('click', this.showInfoM)
        marker.emit('click', { target: marker })
        marker.setMap(this.map)
        marker.on('click', this.markerClick)
      })
      this.map.setFitView()
    },
    weilan1 () {
      // console.log(this.lngLat,'111111111')
      var Polygon = new AMap.Polygon({
        path: this.lngLat,
        borderWeight: 2, // 线条宽度，默认为 1
        strokeColor: '#F33', // 线条颜色
        strokeOpacity: 1, // 线透明度
        fillColor: '#ee2200', // 填充颜色
        fillOpacity: 0.3 // 填充透明度
        // lineJoin: 'round' // 折线拐点连接处样式
      })
      this.map.add(Polygon)
      this.map.setFitView()
    },
    markerClick (e) {
      // console.log(e, '11111')
      this.infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -30) })
      this.infoWindow.setContent(e.target.content)
      this.infoWindow.open(this.map, e.target.getPosition())
    },
    showInfoM (e) {
      console.log(e, '2222')
      // this.vehNo = e.target.w.title
      // this.isDetail = true
      // this.getVehGps()
      // this.getVehInfo()
    },
    searchClick () {
      this.getVehicleMonitor()
    },
    // 重置
    chongZhiClick () {
      this.searchFrom = {
        fleetIds: '',
        vehicleStatus: ''
      }
      this.getVehicleMonitor()
    }
  }
}
</script>
<style scoped lang='less'>
.cont{
  height:100%
}
.map{
  width: 99%;
  margin-top: 12px;
  margin: auto;
  height:89%;
  position: relative;
  background: #ddd;
}
#map{
  width: 100%;
  height: 100%;
}
.searchBox{
  // margin-left: 25px;
}
.inpBox{
  margin: 10px 0 0 -30px;
}
</style>
